import { render, staticRenderFns } from "./MealChip.vue?vue&type=template&id=9fb2a702&scoped=true"
import script from "./MealChip.vue?vue&type=script&lang=ts"
export * from "./MealChip.vue?vue&type=script&lang=ts"
import style0 from "./MealChip.vue?vue&type=style&index=0&id=9fb2a702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb2a702",
  null
  
)

export default component.exports